const initialState = {
  optionsFormRef: null,
  optionsFormReset: null,
  advancedFormRef: null,
  advancedFormReset: null,
};

export const actionTypes = {
  OPTIONS_FORM_REF: 'OPTIONS_FORM_REF',
  OPTIONS_FORM_RESET: 'OPTIONS_FORM_RESET',
  ADVANCED_FORM_REF: 'ADVANCED_FORM_REF',
  ADVANCED_FORM_RESET: 'ADVANCED_FORM_RESET',
};

export const setOptionsFormRef = (formRef) => {
  return {
    type: actionTypes.OPTIONS_FORM_REF,
    formRef,
  };
};

export const setOptionsFormReset = (formReset) => {
  return {
    type: actionTypes.OPTIONS_FORM_RESET,
    formReset,
  };
};

export const setAdvancedFormRef = (formRef) => {
  return {
    type: actionTypes.ADVANCED_FORM_REF,
    formRef,
  };
};

export const setAdvancedFormReset = (formReset) => {
  return {
    type: actionTypes.ADVANCED_FORM_RESET,
    formReset,
  };
};

const formsState = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.OPTIONS_FORM_REF: {
      return {
        ...state,
        optionsFormRef: action.formRef,
      };
    }
    case actionTypes.OPTIONS_FORM_RESET: {
      return {
        ...state,
        optionsFormReset: action.formReset,
      };
    }
    case actionTypes.ADVANCED_FORM_REF: {
      return {
        ...state,
        advancedFormRef: action.formRef,
      };
    }
    case actionTypes.ADVANCED_FORM_RESET: {
      return {
        ...state,
        advancedFormReset: action.formReset,
      };
    }
    default:
      return state;
  }
};

export default formsState;
